import { Link } from "react-router-dom";
import { Check } from "lucide-react";

const packages = [
  {
    name: "Mini Maker",
    price: "from £180",
    tagline: "Up to 6 guests · 2 hrs",
    perks: ["Denim tote OR vinyl tee per guest", "All materials & tools", "Studio styling + mood music", "Pink lemonade & treats"],
    accent: false,
  },
  {
    name: "Studio Soirée",
    price: "from £320",
    tagline: "Up to 10 guests · 3 hrs",
    perks: ["Choice of denim jacket OR vinyl tee + tote", "Polaroid keepsakes", "Personalised invites (digital)", "Photographer-friendly styling corner"],
    accent: true,
  },
  {
    name: "VIP Atelier",
    price: "from £540",
    tagline: "Up to 14 guests · 4 hrs",
    perks: ["Full denim customisation kit per guest", "Vinyl press demo + take-home tee", "Branded party favour bags", "Optional photographer add-on"],
    accent: false,
  },
];

export default function Parties() {
  return (
    <div data-testid="parties-page" className="bg-ink">
      <section className="container-x section-y">
        <p className="overline">Party packages</p>
        <h1 className="mt-4 font-display text-6xl md:text-8xl text-white">
          A birthday<br />they'll never <span className="text-rose">forget.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-white/75 text-lg">
          Three thoughtfully designed packages. Hosted at the studio or styled at your
          venue. Built for ages 8 to grown-up.
        </p>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {packages.map((p) => (
            <article
              key={p.name}
              data-testid={`package-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              className={`relative p-9 border-2 transition-all duration-300 hover:-translate-y-1 ${
                p.accent ? "bg-rose text-white border-white" : "bg-coal text-white border-white"
              }`}
            >
              {p.accent && (
                <div className="absolute -top-3 right-6 tag-gold !rotate-0">MOST LOVED</div>
              )}
              <h3 className="font-display text-4xl uppercase">{p.name}</h3>
              <p className={`mt-1 text-xs uppercase tracking-[0.2em] ${p.accent ? "text-white/80" : "text-white/60"}`}>{p.tagline}</p>
              <p className={`mt-6 font-display text-5xl ${p.accent ? "text-gold" : "text-rose"}`}>{p.price}</p>
              <ul className={`mt-7 space-y-3 text-sm ${p.accent ? "text-white" : "text-white/85"}`}>
                {p.perks.map((perk) => (
                  <li key={perk} className="flex gap-2.5">
                    <Check size={16} className={`${p.accent ? "text-gold" : "text-rose"} flex-shrink-0 mt-0.5`} />
                    <span>{perk}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                className={`mt-9 inline-flex items-center gap-2 px-6 py-3 text-xs font-bold uppercase tracking-[0.2em] border-2 transition ${
                  p.accent ? "bg-ink text-white border-white hover:bg-gold hover:text-ink" : "bg-rose text-white border-white hover:bg-gold hover:text-ink"
                }`}
                style={{ boxShadow: p.accent ? "4px 4px 0 #D4AF37" : "4px 4px 0 #FFFFFF" }}
              >
                Enquire
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-16 card-brutal text-center relative overflow-hidden">
          <div className="splat-gold absolute top-0 right-0" />
          <p className="overline">Bespoke parties</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl text-white">Looking for something different?</h2>
          <p className="mt-4 max-w-2xl mx-auto text-white/75">
            Hen-dos, school enrichment days, brand activations — Miss Lolly is happy to
            tailor a workshop to your group size, age range and budget.
          </p>
          <Link to="/contact" data-testid="bespoke-cta" className="mt-7 inline-flex btn-accent">Tell me about your event</Link>
        </div>
      </section>
    </div>
  );
}
